module.exports = "<label translate>{{ title }}</label>\n<select [(ngModel)]=\"innerValue\"\n        [id]=\"id\"\n        [name]=\"name\"\n        [disabled]=\"disabled\">\n  <option *ngFor=\"let item of list\">{{ item }}</option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-select/ui-simple-select.html
// module id = 1105
// module chunks = 3